import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import Icon from './icon';
import YoutubeIcon from '~icons/simple-icons/youtube';
import TiktokIcon from '~icons/simple-icons/tiktok';
import InstagramIcon from '~icons/simple-icons/instagram';
import PodcastIcon from '~icons/lucide/podcast';
import ImageIcon from '~icons/lucide/image';
import VideoIcon from '~icons/lucide/video';

const PLATFORM_COLORS: Record<string, string> = {
  youtube: 'bg-platform-youtube text-platform-youtube-text',
  tiktok: 'bg-platform-tiktok text-platform-tiktok-text',
  instagram: 'bg-platform-instagram text-platform-instagram-text',
  podcast: 'bg-platform-podcast text-platform-podcast-text',
  image: 'bg-platform-image text-platform-image-text',
};

interface PlatformBadgeSignature {
  Args: {
    platform: string | null | undefined;
  };
  Element: HTMLSpanElement;
}

function platformColor(platform: string | null | undefined): string {
  if (!platform) return 'bg-base-200 text-base-content/60';
  return PLATFORM_COLORS[platform] ?? 'bg-base-200 text-base-content/60';
}

const PlatformBadge: TOC<PlatformBadgeSignature> = <template>
  {{#if @platform}}
    <span
      class="flex h-6 w-6 items-center justify-center rounded-full shadow-sm
        {{platformColor @platform}}"
      ...attributes
    >
      {{#if (eq @platform "youtube")}}
        <Icon @icon={{YoutubeIcon}} class="h-3.5 w-3.5" />
      {{else if (eq @platform "instagram")}}
        <Icon @icon={{InstagramIcon}} class="h-3.5 w-3.5" />
      {{else if (eq @platform "podcast")}}
        <Icon @icon={{PodcastIcon}} class="h-3.5 w-3.5" />
      {{else if (eq @platform "tiktok")}}
        <Icon @icon={{TiktokIcon}} class="h-3.5 w-3.5" />
      {{else if (eq @platform "image")}}
        <Icon @icon={{ImageIcon}} class="h-3.5 w-3.5" />
      {{else}}
        <Icon @icon={{VideoIcon}} class="h-3.5 w-3.5" />
      {{/if}}
    </span>
  {{/if}}
</template>;

export default PlatformBadge;
